import React from 'react'

export default function ForbiddenPage() {
    return (
        <div className="p-8 text-center">
            <h1 className="text-2xl font-bold">접근 권한이 없습니다 (403)</h1>
            <p className="text-slate-600 mt-2">관리자에게 권한을 요청하거나 다른 메뉴를 이용해주세요.</p>
        </div>
    )
}


